import { com } from '@eidu/web'
import Entity = com.eidu.entity.Entity
import SnapshotEntity = com.eidu.entity.publish.SnapshotEntity

const snapshotEntityToEntity = (snapshotEntity: SnapshotEntity): Entity =>
  new Entity(snapshotEntity.entityId, snapshotEntity.typeId, snapshotEntity.valuesByFieldId, snapshotEntity.links)

export default snapshotEntityToEntity
